/**
 * Shared org-list ordering for operator dropdowns.
 *
 * ACTIVE first, then PROVISIONING, then the inactive tail (SUSPENDED,
 * then TERMINATED — the soft-delete state); alphabetical by name within
 * a rank. Used by every org picker that mixes live and dead orgs
 * (LlmProviders resolver-diagnostic, RuntimeFleet per-tenant filter) so
 * the common case (active orgs) sorts to the top while inactive/
 * terminated orgs stay reachable rather than dropped.
 */

import type { Organization, OrgStatus } from "@/types/platform";

// DELETED (slice-3 soft-delete) sorts between SUSPENDED and TERMINATED —
// it's reversible (closer to SUSPENDED) but more removed-feeling than
// SUSPENDED, ahead of TERMINATED which is the final tombstone.
export const ORG_STATUS_RANK: Record<OrgStatus, number> = {
  ACTIVE: 0,
  PROVISIONING: 1,
  SUSPENDED: 2,
  DELETED: 3,
  TERMINATED: 4,
};

export function sortOrgsActiveFirst(list: Organization[]): Organization[] {
  return [...list].sort((a, b) => {
    const ra = ORG_STATUS_RANK[a.status] ?? 9;
    const rb = ORG_STATUS_RANK[b.status] ?? 9;
    return ra !== rb ? ra - rb : a.name.localeCompare(b.name);
  });
}
